import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";

import useGetLocalePath from "../../../hooks/useGetLocalePath";

import { setNavigationIndex } from "../../../redux/reducers/uiReducer";

import Media from "react-media";
import { Link } from "react-router-dom";

import { equalsIgnoringCase } from "../../../utils/validators";

function LandingHeader() {
  const { t } = useTranslation();

  const { getLocalePath } = useGetLocalePath();

  const dispatch = useDispatch();
  const { ui } = useSelector((state) => state);

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      if (!equalsIgnoringCase("landing#about", ui.navigation_index)) {
        dispatch(setNavigationIndex("landing#about"));
      }
    } else {
      dispatch(setNavigationIndex(""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <div ref={ref} id="about" className="landing__header">
      <div className="landing__header__hero">
        <div className="landing__header__hero__content">
          <div className="landing__header__hero__logo">
            <img
              src="../../../assets/images/folder-file-graphic.svg"
              alt={t("landing.hero.img.alt")}
              title={t("landing.hero.img.title")}
              loading="eager"
              width="auto"
              height="auto"
            ></img>
          </div>
          <div className="landing__header__hero__title">
            <h1>{t("landing.hero.title")}</h1>
          </div>
          <div className="landing__header__hero__subtitle">
            <p>{t("landing.hero.subtitle")}</p>
          </div>
          <div className="landing__header__hero__buttons">
            <Media query="(max-width: 576px)">
              <Link
                to={getLocalePath(t("routes.public.uploader"))}
                title={t("uploader_page.title")}
              >
                <button className="button button-primary">
                  <div className="content">
                    <span className="label-title">
                      {t("landing.hero.button.files.title")}
                    </span>
                    <span className="label-subtitle">
                      {t("landing.hero.button.files.subtitle")}
                    </span>
                  </div>
                </button>
              </Link>
            </Media>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingHeader;
